import { apiClient } from "@/api/client";
import type { AdminReport, DashboardOverview } from "@/types/domain";

/** Talks to apps/admin-service (dashboard.service.ts overview, rides.service.ts reports). */
export const dashboardApi = {
  /** GET /admin/dashboard — KPIs + alerts for the ops dashboard. */
  getOverview: () => apiClient.get<DashboardOverview>("/admin/dashboard").then((r) => r.data),

  /** GET /admin/reports?from&to — period KPIs, a 7-day ride/GMV trend, and top pickup zones. */
  getReport: (params?: { from?: string; to?: string }) =>
    apiClient.get<AdminReport>("/admin/reports", { params }).then((r) => r.data),
};
